import {
  pure,
  renderComponent,
  branch,
  compose
} from 'recompose'
import DatePicker from './DatePicker'
import FieldWrapper from './FieldWrapper'

export default compose(
  branch(props => props.formComponent, renderComponent(FieldWrapper)),
  pure
)(DatePicker)



// WEBPACK FOOTER //
// ./components/uiLib/DatePicker/index.js